import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Shipment, Manifest } from 'services/action';
import { Uploader } from 'ui/components';
import { Skeletons, SkeletonText } from 'ui/components/skeleton';

const initialState = {
  isShow: false,
  zoomImg: null,
  data: null,
  imgShow: 4,
};

export const Document = ({ manifest_id, leg_id, privilege }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Get.Image.Leg']
  );

  const StateLoadingDelete = useSelector(
    (state) => state?.Activity?.services['Shipment.Delete.Image']
  );

  const dummy = Array.from({ length: 3 }, (v, i) => i);
  const [{ data, isShow, zoomImg, imgShow }, setState] =
    React.useState(initialState);

  const $onLoad = async (manifest_id, leg_id) => {
    const res = await Dispatch(Manifest.$imageLeg(manifest_id, leg_id));

    if (res?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: res?.data }));
    }
  };

  const $postImage = async (e) => {
    let payload = {
      images: e,
      latitude: 0,
      longitude: 0,
    };

    const req = await Dispatch(Manifest.$uploadImageLeg(manifest_id, leg_id, payload));

    if (req?.message === 'success') {
      $onLoad(manifest_id, leg_id);
    }
  };

  const $deleteImage = async (e) => {
    const req = await Dispatch(Shipment.$deleteImageByURL(e));

    if (req?.message === 'success') {
      $onLoad(manifest_id, leg_id);
      setState((prevState) => ({
        ...prevState,
        isShow: false,
      }));
    }
  };

  React.useEffect(() => {
    $onLoad(manifest_id, leg_id);
  }, [manifest_id, leg_id]);

  if (!data && !privilege) return null;

  return (
    <section className="" id="doc">
      {StateLoading ? (
        <div style={{ width: 100 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="datagrid-title mb-3 mt-md-3 mt-3 border-bottom pb-1">
          Dokumentasi
        </div>
      )}

      {StateLoading ? (
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-start pt-2">
          {dummy?.map((d, i) => (
            <Skeletons width="50px" height="50px" key={i} />
          ))}
          <Skeletons width="50px" height="50px" />
        </div>
      ) : (
        <div
          className={cn(
            'd-flex flex-wrap pb-2 gap-2 align-items-center justify-content-start'
          )}
        >
          {privilege && <Uploader small setData={(e) => $postImage(e)} />}

          {data?.slice(0, imgShow)?.map((d, i) => (
            <div key={i} style={{ width: 50, height: 50 }}>
              <img
                className="img-hover small rounded-3"
                src={d?.image}
                alt=""
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    isShow: true,
                    zoomImg: d,
                  }));
                }}
              />
            </div>
          ))}

          {data?.length > 4 ? (
            imgShow < data?.length ? (
              <div
                className="d-flex flex-column justify-content-center align-items-center bg-secondary-lt text-uppercase fw-bold rounded-3 uploader "
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    imgShow: data?.length,
                  }))
                }
                style={{ cursor: 'pointer', height: 50, width: 50 }}
              >
                <div
                  className=""
                  style={{
                    textOrientation: 'upright',
                    writingMode: 'horizontal-tb',
                    textAlign: 'center',
                    fontSize: 10,
                  }}
                >
                  <Fi.FiChevronsRight size={20} />
                </div>
              </div>
            ) : (
              <div
                className="d-flex flex-column justify-content-center align-items-center bg-secondary-lt text-uppercase fw-bold rounded-3 uploader "
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    imgShow: 4,
                  }))
                }
                style={{ cursor: 'pointer', height: 50, width: 50 }}
              >
                <div
                  className=""
                  style={{
                    textOrientation: 'upright',
                    writingMode: 'horizontal-tb',
                    textAlign: 'center',
                    fontSize: 10,
                  }}
                >
                  <Fi.FiChevronsLeft size={20} />
                </div>
              </div>
            )
          ) : null}
        </div>
      )}

      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({
            ...prevState,
            isShow: false,
          }))
        }
        backdrop="static"
        centered
        className="text-center"
        size="lg"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                isShow: false,
              }))
            }
          />
          <div className="text-center mt-4">
            <img src={zoomImg?.image?.replace('_thumb', '')} alt="" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div
            className={
              StateLoadingDelete
                ? 'btn btn-danger btn-loading'
                : 'btn btn-danger'
            }
            onClick={() => $deleteImage(zoomImg?.image)}
          >
            Hapus Gambar
          </div>
        </Modal.Footer>
      </Modal>
    </section>
  );
};
